import React from "react";
import { EyeOutlined, GithubOutlined } from "@ant-design/icons";
import { Button, Card, Col, Image } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Meta from "antd/lib/card/Meta";

const Project = ({ project }) => {
  const { name, image, description, Github, live, use } = project;
  return (
    <>
      <Col xs={23} sm={23} md={12} lg={12} xl={10} xxl={10}>
        <Card
          title={name}
          cover={<Image alt={name} src={image} />}
          style={{ height: "100%" }}
        >
          <Meta description={description} />
          <Paragraph strong> Technology : {use} </Paragraph>
          <a href={live} target="_blank" rel="noreferrer">
            {" "}
            <Button type="primary" ghost>
              <EyeOutlined /> Live
            </Button>
          </a>
          <a href={Github} target="_blank" rel="noreferrer">
            {" "}
            <Button type="primary" ghost danger style={{ float: "right" }}>
              <GithubOutlined /> Github
            </Button>{" "}
          </a>
        </Card>
      </Col>
    </>
  );
};

export default Project;
